import { render } from "./OrgUnitDeleteModal.vue?vue&type=template&id=af35d214"
import script from "./OrgUnitDeleteModal.vue?vue&type=script&lang=js"
export * from "./OrgUnitDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__